import {Component, Input, OnDestroy, OnInit, Output, EventEmitter} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'app-fuse-splash-screen-platform',
  templateUrl: './fuse-splash-screen-platform.component.html',
  styleUrls: ['./fuse-splash-screen-platform.component.scss']
})
export class FuseSplashScreenPlatformComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;

  @Input() type: string;
  @Output() createMemo = new EventEmitter<boolean>();

  unSubscribe$ = new Subject<void>();
  checked: boolean;

  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private router: Router,
    private snackBarService: SnackBarService,
  ) {
    this.checked = false;
  }

  ngOnInit() {
  }

  orbitaxPlatformOnboardingNext() {
    this.createReport(null, this.type );
  }

  createReport(title, type) {
    this.createMemo.emit(true);
    if (this.magicLinkModel && this.magicLinkModel.additionalCommands['CreateMemoCommand']) {
      const command = this.magicLinkModel.additionalCommands['CreateMemoCommand'];
      this.handler.executeCommand(command);
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onLoad() {
    this.type = this.magicLinkModel.fieldValues['MemoType'];
  }

  onBeforeExecuteNextCommand(): boolean {
    return undefined;
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecutePreviousCommand(): boolean {
    return undefined;
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

}
